import { ColorAdvice5, ColorClubMatasPlus5, ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import { _LoginInfo, type _LoginInfoParams } from 'autogen/swagger/all';
import { GeneralExceptionError } from 'autogen/translation-keys/trans-website-shared-error';
import toast from 'components/Toast';
import i18next from 'i18next';

export default async function OpenLoginModal(params: _LoginInfoParams) {
    try {
        const response = await _LoginInfo(params);

        const theme = { minWidth: 'unset', maxWidth: '375px', backgroundColor: ColorNeutralWhite };

        switch (response.type) {
            case 'MatasPlusQuickSignup':
            case 'MatasPlusMixedSignup':
                theme.backgroundColor = ColorClubMatasPlus5;
                break;
            case 'BestForYou':
                theme.backgroundColor = ColorAdvice5;
                break;
            default:
                break;
        }

        const { default: LoginInfo } = await import(/* webpackChunkName: "loginInfo" */ 'components/login/loginInfo');
        const { default: createModal } = await import(/* webpackChunkName: "modal" */ 'modules/modal');
        const modal = createModal();

        return modal({
            open: true,
            layout: { customTheme: theme },
            content: <LoginInfo model={response} modal={modal} />
        });
    } catch (error) {
        console.error(error);
        toast.error(i18next.t(GeneralExceptionError));
    }
}
